const body = qs('body')

/* Screen size variables */

const mobileSize = 768
const tabletSize = 1024
const desktopSize = 1028

/* Open Cart */

const cartToggles = qsa('[data-cart-toggle]')

cartToggles.forEach((toggle) => {
	toggle.addEventListener('click', (e) => {
		e.preventDefault()
		cartToggle()
		searchToggle('close')
		navToggle('close')
		headerInner.classList.add('active')
	})
})

const searchToggles = qsa('[data-search-toggle]')

searchToggles.forEach((toggle) => {
	toggle.addEventListener('click', (e) => {
		e.preventDefault()
		searchToggle()
		cartToggle('close')
		navToggle('close')
		headerInner.classList.add('active')
	})
})

document.addEventListener('DOMContentLoaded', () => {
	const searchForms = document.querySelectorAll('predective-search form')

	searchForms.forEach((form) => {
		const input = form.querySelector('input[type="search"]')

		input.addEventListener('keydown', (e) => {
			if (e.key == 'Enter') {
				e.preventDefault()
				form.submit()
			}
		})
	})
})

const detailLinks = [...qsa('details a'), ...qsa('details button')]

detailLinks.forEach((link) => {
	link.addEventListener('click', (e) => {
		e.stopPropagation()
	})
})

/* Details Animator */
const details = document.querySelectorAll('details')

if (details) {
	details.forEach((targetDetail) => {
		targetDetail.addEventListener('click', function (e) {
			if (targetDetail.hasAttribute('open')) {
				e.preventDefault()
				targetDetail.classList.add('closing')
				setTimeout(() => {
					targetDetail.removeAttribute('open')
					targetDetail.classList.remove('closing')
				}, 390)
			}
		})
	})
}

/* Liquid Ajax Cart */

liquidAjaxCart.subscribeToCartAjaxRequests((state, subscribeToResult) => {
	if (state.requestType == 'add') {
		const form = state.info.initiator
		let btnInner = ''

		const container = Array.from(
			form.querySelectorAll('[data-adding-container]')
		)
		const button = form.querySelector('button[type="submit"]')

		const btn = [...container, button][0]

		const hideAdding = btn.dataset.hideAdding
		if (btn && !hideAdding) {
			btnInner = btn.innerHTML

			btn.innerHTML = 'Adding'
		}

		subscribeToResult((state) => {
			const btn = form.querySelector('button[type="submit"]')
			if (state.responseData.ok) {
				cartToggle('open')
				mobileHamburger.classList.toggle('active')
				mobileHamburger.dataset.mobileToggle = 'cart'
				headerInner.classList.add('active')
			}

			if (btn) {
				setTimeout(() => {
					btn.innerHTML = btnInner
				}, 300)
			}
		})
	}
})

/* Header Navigation Interactions */

//todo refactor all modal state to use one function

const navigationToggles = qsa('[data-navigation-toggle]')
const headerBg = qs('#headerBg')
navigationToggles.forEach((toggle) => {
	toggle.addEventListener('mouseenter', (e) => {
		const title = toggle.dataset.navigationToggle
		const exToggle = qs('[data-navigation-toggle].active')

		const content = qs(`[data-navigation-item="${title}"]`)
		const exContent = qs('[data-navigation-item].active')

		if (exContent != content) {
			header.classList.add('active')
			content.classList.add('active')

			toggle.classList.add('active')
			toggle.setAttribute('aria-expanded', true)

			exContent && exContent.classList.remove('active')
			exToggle && exToggle.classList.remove('active')
			exToggle && exToggle.setAttribute('aria-expanded', false)
		} else if (content == exContent) {
			content.classList.remove('active')
			header.classList.remove('active')
			toggle.setAttribute('aria-expanded', false)
			toggle.classList.remove('active')
		}
	})
	toggle.addEventListener('click', (e) => {
		e.preventDefault()

		const title = toggle.dataset.navigationToggle

		const content = qs(`[data-navigation-item="${title}"]`)
		const exContent = qs('[data-navigation-item].active')

		const exToggle = qs('[data-navigation-toggle].active')

		if (exContent == content) {
			header.classList.remove('active')
			content.classList.remove('active')
			toggle.setAttribute('aria-expanded', false)
			toggle.classList.remove('active')
		} else {
			header.classList.add('active')
			content.classList.add('active')

			toggle.classList.add('active')
			toggle.setAttribute('aria-expanded', true)

			exContent && exContent.classList.remove('active')
			exToggle && exToggle.classList.remove('active')
			exToggle && exToggle.setAttribute('aria-expanded', false)
		}
	})
})

headerBg.addEventListener('mouseenter', (e) => {
	const exToggle = qs('[data-navigation-toggle].active')
	const exContent = qs('[data-navigation-item].active')

	exToggle && exToggle.classList.remove('active')
	exToggle && exToggle.setAttribute('aria-expanded', false)
	exContent && exContent.classList.remove('active')
	header.classList.remove('active')
})

const mobileNavigationToggles = qsa('[data-mobile-nav-toggle]')
const mobileHamburger = qs('#mobileHamburger')
const mobileNavigation = qs('#mobileNavigation')
const mobileHeaderToggles = qsa('[data-header-toggle]')

mobileNavigationToggles.forEach((toggle) => {
	toggle.addEventListener('click', (e) => {
		mobileHamburger.classList.toggle('active')
		navToggle()
		searchToggle('close')
		cartToggle('close')
	})
})

mobileHeaderToggles.forEach((btn) => {
	btn.addEventListener('click', (e) => {
		e.preventDefault()
		const active = mobileHamburger.classList.contains('active')
		const element = btn.dataset.headerToggle
		const current = mobileHamburger.dataset.mobileToggle

		if (!active) {
			mobileHamburger.classList.toggle('active')
		} else {
			if (element == current) {
				mobileHamburger.classList.remove('active')
			}
		}

		mobileHamburger.dataset.mobileToggle = element
	})
})

mobileHamburger.addEventListener('click', (e) => {
	e.preventDefault()
	const current = mobileHamburger.dataset.mobileToggle
	mobileHamburger.classList.toggle('active')
	const active = mobileHamburger.classList.contains('active')

	if (!active) {
		body.classList.remove('disable-scroll')
		if (current == 'nav') {
			navToggle('close')
		}
	} else {
		if (current == 'nav') {
			navToggle('open')
		}
	}

	searchToggle('close')
	cartToggle('close')

	mobileHamburger.dataset.mobileToggle = 'nav'
})
const mobileNavigatioNMenuToggles = qsa('[data-mobile-navigation-button]')
mobileNavigatioNMenuToggles.forEach((toggle) => {
	toggle.addEventListener('click', (e) => {
		const title = toggle.dataset.mobileNavigationButton
		const exToggle = qs('[data-mobile-navigation-button].active')
		const content = qs(`[data-mobile-navigation-item="${title}"]`)
		const exContent = qs('[data-mobile-navigation-item].active')

		if (content && exContent != content) {
			toggle.classList.add('active')
			toggle && toggle.setAttribute('aria-expanded', true)

			content.classList.add('active')
			exContent && exContent.classList.remove('active')
			exToggle && exToggle.classList.remove('active')
			exToggle && exToggle.setAttribute('aria-expanded', false)
		}
	})
})

/* Product Card Buy Now Button */

const buyNowButtons = qsa('[data-product-card-buy-now]')

buyNowButtons.forEach((btn) => {
	btn.addEventListener('click', (e) => {
		e.preventDefault()

		let btnInner = btn.innerHTML

		const card = btn.closest('form')
		const id = qs('input[name="id"]', card).value

		btn.innerHTML = 'Adding'

		if (id) {
			fetch('/cart/add.js', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({
					id: id,
					quantity: 1
				})
			}).then(() => {
				btn.innerHTML = btnInner
				window.location.href = '/checkout'
			})
		}
	})
})

/* enterview */

let reveals = qsa('.reveal')

if (reveals.length > 0) {
	enterView({
		selector: '.reveal',
		enter: (el, i) => {
			el.classList.add('entered')
		},
		exit: (el) => {
			el.classList.remove('entered')
		},
		offset: 0.1
	})
}

function updateReveals() {
	enterView({
		selector: '.reveal',
		enter: (el, i) => {
			el.classList.add('entered')
		},
		exit: (el) => {
			el.classList.remove('entered')
		},
		offset: 0.1
	})
}

/* Ajaxination */
var endlessScroll = new Ajaxinate({
	container: '#paginationContainer',
	pagination: '#paginationButton',
	method: 'click',
	callback: updateReveals
})

/* Load video on enter */

const llVideos = document.querySelectorAll('.video-ll')

if (llVideos.length > 0) {
	enterView({
		selector: '.video-ll',
		enter: function (el) {
			el.load()
			el.play()
		},
		offset: 0.1
	})
}

/* Header Headroom */

const header = qs('#header')
const localization = qs('#localizationSelector')

const headroomOptions = {
	offset: {
		up: 50,
		down: 100
	},
	classes: {
		pinned: 'header-wrapper--pinned',
		unpinned: 'header-wrapper--unpinned',
		top: 'header-wrapper--top'
	},
	onUnpin: () => {
		localization.classList.remove('active')
		header.classList.remove('active')
	}
}
const headroom = new Headroom(header, headroomOptions)
headroom.init()

/* Homepage Hero Landing Swiper */

const heroLandingSwipers = qsa('[data-hero-swiper]')

heroLandingSwipers.forEach((sw) => {
	const desktopPagination = qs('[data-pagination]', sw)
	const mobilePagination = qs('[data-mobile-pagination]', sw)

	const nextEl = qs('[data-next-button]', sw)
	const prevEl = qs('[data-prev-button]', sw)

	const delay = sw.dataset.delay
	const swiper = new Swiper(sw, {
		direction: 'horizontal',
		loop: true,
		slidesPerView: 1,
		speed: 700,
		autoplay: {
			delay: delay ?? 5000
		},
		navigation: {
			nextEl,
			prevEl
		},
		pagination: {
			el: mobilePagination,
			type: 'bullets',
			clickable: true
		},
		breakpoints: {
			768: {
				pagination: {
					el: desktopPagination,
					type: 'progressbar'
				}
			}
		}
	})
})

/* Cards Swiper */

const cardsSwiper = qsa('[data-cards-swiper]')

cardsSwiper.forEach((sw) => {
	const pagination = qs('.progress-bar', sw)
	const swiper = qs('.swiper-container', sw)
	const nextEl = qs('[data-swiper-next]', sw)
	const prevEl = qs('[data-swiper-prev]', sw)
	const slides = qsa('.swiper-slide', sw)
	const slideLength = Number(sw.dataset.slides)
	const mobileSlideLength = Number(sw.dataset.mobileSlides)

	const _swiper = new Swiper(swiper, {
		direction: 'horizontal',
		loop: false,
		autoHeight: false,
		slidesPerView: mobileSlideLength ? mobileSlideLength : 1.7,
		spaceBetween: 12,
		loop: false,
		speed: 700,
		mousewheel: {
			forceToAxis: true
		},
		pagination: {
			el: pagination,
			type: 'progressbar',
			clickable: true
		},
		navigation: {
			nextEl,
			prevEl
		},
		breakpoints: {
			768: {
				slidesPerView: slideLength ? slideLength : slides.length > 5 ? 4 : 4.25
			}
		}
	})
})

// Product Card Swiper

const productCards = qsa('[data-product-card]')

productCards.forEach((card) => {
	const cardSwiper = qs('[data-product-card-swiper]', card)

	if (!cardSwiper) return

	const swiper = new Swiper(cardSwiper, {
		direction: 'horizontal',
		loop: false,
		allowTouchMove: false,
		nested: true,
		slidesPerView: 1,
		spaceBetween: 1,
		speed: 400,
		effect: 'fade',
		fadeEffect: {
			crossFade: true
		}
	})
	const variantSwatches = qsa('[data-variant-swatch]', card)
	const images = qsa('.swiper-slide', card)
	const idInput = qs('[data-variant-id]', card)

	variantSwatches.forEach((swatch) => {
		const id = swatch.dataset.variantSwatch
		const image = images.find((img) => img.dataset.variantImage == id)
		const imageIdx = images.indexOf(image)

		swatch.addEventListener('click', (e) => {
			e.preventDefault()
			if (idInput) {
				idInput.value = id
			}
			swiper.slideTo(imageIdx)
		})
	})
})

const solutionParallax = qsa('[data-solution-parallax]')

solutionParallax.forEach((module) => {
	const items = qs('[data-solution-parallax-items]', module)
	const listener = qs('[data-solution-parallax-listener]', module)
	if (!items || !listener) return

	let wrapperWidth = listener.offsetWidth
	let itemsWidth = items.scrollWidth
	let difference = itemsWidth - wrapperWidth + 48

	function init() {
		wrapperWidth = listener.offsetWidth
		itemsWidth = items.scrollWidth
		difference = itemsWidth - wrapperWidth + 48
	}
	window.addEventListener('resize', init)

	module.addEventListener('mousemove', (e) => {
		const rect = module.getBoundingClientRect()
		const pos = e.clientX - rect.left
		const ratio = (pos / itemsWidth).toFixed(1)
		const movement = difference * (1 - 2 * ratio)

		items.style.transform = `translateX(${movement}px)`
	})

	module.addEventListener('mouseleave', (e) => {
		items.style.transform = `translateX(0px)`
	})
})

/* Hero Reviews Swiper*/

const heroReviewsSwipers = qsa('[data-hero-reviews-swiper]')

heroReviewsSwipers.forEach((module) => {
	const _swiper = qs('.swiper-container', module)
	const pagination = qs('[data-reviews-pagination]')

	const delay = Number(module.dataset.delay)

	if (!_swiper) return

	const swiper = new Swiper(_swiper, {
		slidesPerView: 1,
		pagination: {
			el: pagination,
			type: 'bullets',
			clickable: true
		},
		slidesPerView: 1,
		speed: 400,
		effect: 'fade',
		fadeEffect: {
			crossFade: true
		},
		autoplay: {
			delay: delay ?? 5000
		}
	})
})

/* Featured Links Mobile Swiper */

const featuredLinksSwiper = qsa('[data-featured-links-swiper]')

featuredLinksSwiper.forEach((sw) => {
	const pagination = qs('.progress-bar', sw)
	const swiper = qs('.swiper-container', sw)

	new Swiper(swiper, {
		direction: 'horizontal',
		loop: false,
		autoHeight: false,
		slidesPerView: 1.02,
		spaceBetween: 12,
		loop: false,
		speed: 700,
		mousewheel: {
			forceToAxis: true
		},
		pagination: {
			el: pagination,
			type: 'progressbar',
			clickable: true
		}
	})
})

const collectionNavigation = qsa('[data-collection-navigation-slider]')

collectionNavigation.forEach((nav) => {
	const swiper = new Swiper(nav, {
		direction: 'horizontal',
		loop: false,
		autoHeight: false,
		slidesPerView: 1.25,
		loop: false,
		speed: 700,
		mousewheel: {
			forceToAxis: true
		},
		breakpoints: {
			768: {
				slidesPerView: 4.5
			}
		}
	})
})

const mobileCollectionNavigationBtn = qs('#mobileCollectionNavButton')
const mobileCollectionNavigationItems = qs('#mobileCollectionNavItems')

if (mobileCollectionNavigationBtn) {
	mobileCollectionNavigationBtn.addEventListener('click', (e) => {
		if (!mobileCollectionNavigationItems) return
		mobileCollectionNavigationBtn.classList.toggle('active')
		mobileCollectionNavigationItems.classList.toggle('active')
	})
}

const collectionSorting = qs('#collectionSorting')

if (collectionSorting) {
	const collectionSortingBtn = qs('button', collectionSorting)
	collectionSortingBtn.addEventListener('click', (e) => {
		collectionSorting.classList.toggle('active')
	})
}

const collectionFeaturedGrid = qsa('[data-collection-featured-grid]')

collectionFeaturedGrid.forEach((grid) => {
	const _swiper = qs('.swiper-container', grid)
	const pagination = qs('.progress-bar', grid)

	const swiper = new Swiper(_swiper, {
		direction: 'horizontal',
		loop: false,
		autoHeight: false,
		slidesPerView: 1.25,
		spaceBetween: 12,
		loop: false,
		speed: 700,
		mousewheel: {
			forceToAxis: true
		},
		pagination: {
			el: pagination,
			type: 'progressbar',
			clickable: true
		}
	})
})

const productCarouselSwiper = qs('#productCarousel')

if (productCarouselSwiper) {
	const swiperEl = qs('.swiper-container', productCarouselSwiper)
	const thumbnailsEl = qs('#productCarouselThumbnails', productCarouselSwiper)

	const thumbnails = new Swiper(thumbnailsEl, {
		direction: 'horizontal',
		autoHeight: false,
		slidesPerView: 'auto',
		spaceBetween: 0,
		loop: false,
		watchSlidesProgress: true
	})

	const swiper = new Swiper(swiperEl, {
		direction: 'horizontal',
		loop: false,
		autoHeight: false,
		slidesPerView: 1,
		spaceBetween: 1,
		keyboard: {
			enabled: true,
			onlyInViewport: true
		},
		mousewheel: {
			forceToAxis: true
		},
		speed: 400,
		thumbs: {
			swiper: thumbnails
		}
	})

	const lightboxTrigger = qs('#lightboxTrigger')
	const lightbox = qs('#lightbox')
	const lightboxClose = qs('#lightboxClose')
	const lightboxNextBtn = qs('#lightboxNext')
	const lightboxPrevBtn = qs('#lightboxPrev')
	const lightboxPagination = qs('.lightbox-pagination', lightbox)

	const lightboxThumbnailSwiper = new Swiper('#lightboxThumbnailSwiper', {
		direction: 'horizontal',
		slidesPerView: 18,
		spaceBetween: 10,
		loop: true,
		watchSlidesProgress: true
	})

	const lightboxSwiper = new Swiper('#lightboxSwiper', {
		slidesPerView: 1,
		centeredSlides: true,
		zoom: {
			minRatio: 1,
			maxRatio: 3
		},
		thumbs: {
			swiper: lightboxThumbnailSwiper
		},
		navigation: {
			nextEl: lightboxNextBtn,
			prevEl: lightboxPrevBtn
		},
		keyboard: {
			enabled: true
		},
		pagination: {
			el: lightboxPagination,
			type: 'fraction',
			clickable: true
		}
	})
	if (lightboxTrigger) {
		lightboxTrigger.addEventListener('click', () => {
			const activeSlide = swiper.activeIndex
			lightboxSwiper.slideTo(activeSlide)
			lightbox.showModal()
			body.classList.add('disable-scroll')
		})

		lightboxClose.addEventListener('click', () => {
			lightbox.close()
		})
	}

	lightbox.addEventListener('close', () => {
		body.classList.remove('disable-scroll')
	})
}

// Interactive Gallery

const interactiveGalleries = qsa('[data-interactive-gallery]')

interactiveGalleries.forEach((module) => {
	const steps = qs('[data-step]', module)
	if (!steps) return

	const cursor = qs('[data-cursor]', module)

	steps.addEventListener('click', (e) => {
		e.preventDefault
		let idx = Number(steps.dataset.step)
		const newIndex = idx == 4 ? 1 : idx + 1
		steps.setAttribute('data-step', newIndex)
	})

	steps.addEventListener('mouseover', (e) => {
		cursor.classList.add('active')
	})
	steps.addEventListener('mouseleave', (e) => {
		cursor.classList.remove('active')
	})

	steps.addEventListener('pointermove', (e) => {
		const { offsetX, offsetY } = e
		const elWidth = steps.scrollWidth
		const leftThreshold = elWidth - 400

		cursor.animate(
			{
				left:
					leftThreshold > offsetX ? `${offsetX + 60}px` : `${offsetX - 180}px`,
				top: `${offsetY + 20}px`
			},
			{ duration: 300, fill: 'forwards' }
		)
	})
})

const productFeaturesButtons = qsa('[data-feature-button]')
const productFeaturesImages = qsa('[data-feature-image]')

productFeaturesButtons &&
	productFeaturesButtons.forEach((btn) => {
		btn.addEventListener('click', (e) => {
			e.preventDefault()
			const title = btn.dataset.featureButton
			const ex = qs('[data-feature-button].active')
			const exImage = qs('[data-feature-image].active')
			const image = qs(`[data-feature-image="${title}"]`)
			ex && ex.classList.remove('active')
			exImage && exImage.classList.remove('active')

			image && image.classList.add('active')
			btn.classList.add('active')
		})
	})

productFeaturesImages &&
	productFeaturesImages.forEach((image) => {
		const tooltips = qsa('[data-info-tooltip-toggle]', image)
		const mobileToggles = qsa('[data-mobile-modal-hide]', image)
		tooltips.forEach((tip) => {
			tip.addEventListener('mouseenter', (e) => {
				if (window.innerWidth > 1024) {
					const ex = qs('[data-info-tooltip-toggle].active', image)
					if (ex != tip) {
						tip.classList.add('active')
						ex && ex.classList.remove('active')
					}
					if (ex == tip) {
						tip.classList.remove('active')
						console.log('remove')
					}
				}
			})
			tip.addEventListener('click', (e) => {
				if (window.innerWidth <= 1024) {
					const ex = qs('[data-info-tooltip-toggle].active', image)
					console.log('happening here')
					if (ex != tip) {
						console.log('is this toggling active?', ex)
						tip.classList.add('active')
						ex && ex.classList.remove('active')
						console.log('tip', tip)
					}
					if (ex == tip) {
						tip.classList.remove('active')
					}
				}
			})
		})

		mobileToggles.forEach((toggle) => {
			if (window.innerWidth < 768) {
				toggle.addEventListener('click', (e) => {
					const ex = qs('[data-info-tooltip-toggle].active', image)

					ex.classList.remove('active')
				})
			}
		})
	})

const tooltipModules = qsa('[data-tooltip-module]')

tooltipModules.forEach((module) => {
	const productToolTips = qsa('[data-product-tooltip]', module)

	productToolTips &&
		productToolTips.forEach((tip) => {
			tip.addEventListener('mouseover', (e) => {
				e.preventDefault()

				const ex = qs('[data-product-tooltip].active', module)

				ex && ex.classList.remove('active')
				tip.classList.add('active')
			})
		})
})

const productFeaturesSelect = qs('#productFeaturesSelect')

productFeaturesSelect &&
	productFeaturesSelect.addEventListener('change', (e) => {
		const value = e.target.value

		const exImage = qs('[data-feature-image].active')
		const image = qs(`[data-feature-image="${value}"]`)
		exImage && exImage.classList.remove('active')

		image && image.classList.add('active')
	})

const userBenefitsSwipers = qsa('[data-user-benefits-swiper]')

userBenefitsSwipers.forEach((module) => {
	const _swiper = qs('.swiper-container', module)
	const pagination = qs('.progress-bar', module)
	const nextEl = qs('[data-swiper-next]', module)
	const prevEl = qs('[data-swiper-prev]', module)

	const swiper = new Swiper(_swiper, {
		direction: 'horizontal',
		loop: false,
		autoHeight: true,
		slidesPerView: 1.25,
		spaceBetween: 12,
		loop: false,
		speed: 700,
		mousewheel: {
			forceToAxis: true
		},
		pagination: {
			el: pagination,
			type: 'progressbar',
			clickable: true
		},
		navigation: {
			nextEl,
			prevEl
		},
		breakpoints: {
			768: {
				slidesPerView: 4.25
			}
		}
	})
})

const compareKitsCarousel = qsa('[data-compare-kits-swiper]')
const kitItems = qsa('[data-compare-kit-item]')

compareKitsCarousel.forEach((module) => {
	const _swiper = qs('.swiper-container', module)
	const desktopPagination = qs('[data-pagination]', module)
	const mobilePagination = qs('[data-mobile-pagination]', module)

	const kitItems = qsa('[data-compare-kit-item]', module)
	const itemBtns = qsa('[data-mobile-select-btn]', module)
	const itemVariants = qsa('[data-mobile-variant-item]', module)

	const prevEl = qs('[data-prev-button]', module)
	const nextEl = qs('[data-next-button]', module)

	const handleSlideChange = (e) => {
		const idx = e.activeIndex

		kitItems.forEach((item, i) => {
			item.toggleAttribute('open', i === idx)
		})
		const active = itemVariants[idx]
		const inner = active.dataset.mobileVariantItem
		const ex = qs('[data-mobile-variant-item].active', module)

		if (active != ex) {
			ex.classList.remove('active')
			active.classList.add('active')
			compareKitsMobileSelectBtnInner.innerHTML = inner
		}
	}

	const swiper = new Swiper(_swiper, {
		direction: 'horizontal',
		loop: false,
		autoHeight: false,
		slidesPerView: 1,
		loop: false,
		speed: 700,
		allowTouchMove: true,
		mousewheel: {
			forceToAxis: true
		},
		pagination: {
			el: mobilePagination,
			type: 'bullets',
			clickable: false
		},
		on: {
			activeIndexChange: (e) => handleSlideChange(e)
		},
		navigation: {
			prevEl,
			nextEl
		},
		breakpoints: {
			768: {
				allowTouchMove: true,
				pagination: {
					el: desktopPagination,
					type: 'progressbar',
					clickable: false
				}
			}
		}
	})

	kitItems.forEach((item, i) => {
		item.addEventListener('click', (e) => {
			e.preventDefault()
			swiper.slideTo(i)
		})
	})

	const compareKitsMobileSelectBtn = qs(
		'[data-compare-kits-mobile-select-btn]',
		module
	)
	const compareKitsMobileSelectBtnInner = qs('span', compareKitsMobileSelectBtn)
	const compareKitsMobileSelect = qs(
		'[data-compare-kits-mobile-select]',
		module
	)

	compareKitsMobileSelectBtn.addEventListener('click', () => {
		compareKitsMobileSelect.classList.toggle('active')
	})

	itemBtns.forEach((item, i) => {
		item.addEventListener('click', () => {
			const ex = qs('[data-mobile-variant-item].active', module)
			const exBtn = qs('[data-mobile-select-btn].hidden', module)
			const active = itemVariants[i]
			const inner = item.textContent

			if (active != ex) {
				ex.classList.remove('active')
				exBtn.classList.remove('hidden')

				active.classList.add('active')
				item.classList.add('hidden')
				compareKitsMobileSelectBtnInner.innerHTML = inner
				swiper.slideTo(i)
			}
			compareKitsMobileSelect.classList.remove('active')
		})
	})
})

const videoReviewsSwipers = qsa('[data-video-reviews-swiper]')

videoReviewsSwipers.forEach((module) => {
	const _swiper = qs('.swiper-container', module)
	const desktopPagination = qs('[data-pagination]', module)
	const mobilePagination = qs('[data-mobile-pagination]', module)

	const prev = qs('[data-prev-button]', module)
	const next = qs('[data-next-button]', module)

	const swiper = new Swiper(_swiper, {
		direction: 'horizontal',
		loop: false,
		autoHeight: false,
		loop: false,
		speed: 700,
		spaceBetween: 20,
		slidesPerView: 1.1,
		navigation: {
			prevEl: prev,
			nextEl: next
		},
		mousewheel: {
			forceToAxis: true
		},
		pagination: {
			el: mobilePagination,
			type: 'progressbar',
			clickable: true
		},
		breakpoints: {
			768: {
				slidesPerView: 3,
				pagination: {
					el: desktopPagination,
					type: 'progressbar'
				}
			}
		}
	})
})

const productSpecficationModules = qsa('[data-product-specifications]')

productSpecficationModules.forEach((module) => {
	const _swiper = qs('.swiper-container', module)
	const mobilePagination = qs('[data-mobile-pagination]', module)
	const desktopPagination = qs('[data-pagination]', module)

	const next = qs('[data-next-button]', module)
	const prev = qs('[data-prev-button]', module)

	const swiper = new Swiper(_swiper, {
		direction: 'horizontal',
		loop: false,
		autoHeight: false,
		loop: false,
		speed: 700,
		spaceBetween: 20,
		slidesPerView: 1,
		navigation: {
			nextEl: next,
			prevEl: prev
		},
		mousewheel: {
			forceToAxis: true
		},
		pagination: {
			el: mobilePagination,
			type: 'bullets',
			clickable: true
		},
		breakpoints: {
			768: {
				pagination: {
					el: desktopPagination,
					type: 'progressbar',
					clickable: true
				}
			}
		}
	})
})

/* Product Intersection */
const quickAtc = qs('#productQuickAtc')
const productBreadcrumbs = qs('#productBreadcrumbs')
const productMeta = qs('#product-form')
const footer = qs('#footer')

const headerInner = qs('.header', header)

if (productMeta) {
	const quickAtcObserver = new IntersectionObserver(
		([entry]) => {
			if (!entry.isIntersecting) {
				quickAtc.classList.add('active')
			} else {
				quickAtc.classList.remove('active')
			}
		},
		{
			root: null,
			threshold: 0
		}
	)
	quickAtcObserver.observe(productMeta)

	const mainObserver = new IntersectionObserver(
		([entry]) => {
			if (!entry.isIntersecting) {
				headerInner.classList.remove('header--transparent')
			} else {
				headerInner.classList.add('header--transparent')
			}
		},
		{
			root: null,
			threshold: 0
		}
	)
	mainObserver.observe(productBreadcrumbs)

	const footerObserver = new IntersectionObserver(
		([entry]) => {
			if (!entry.isIntersecting) {
				if (window.scrollY > 200) {
					quickAtc.classList.add('active')
				}
			} else {
				quickAtc.classList.remove('active')
			}
		},
		{
			root: null,
			threshold: 0.1
		}
	)
	footerObserver.observe(footer)
}

const adventureCarouselElements = qsa('[data-adventure-carousel]')

adventureCarouselElements.forEach((module) => {
	const swiperEl = qs('.swiper-container', module)

	const swiper = new Swiper(swiperEl, {
		slidesPerView: 1.8,
		spaceBetween: 32,
		centeredSlides: true,
		speed: 3000,
		autoplay: {
			delay: 0
		},
		loop: true,
		effect: 'coverflow',
		autoHeight: true,
		mousewheel: {
			forceToAxis: true
		},
		coverflowEffect: {
			rotate: 0,
			stretch: 40,
			depth: 250,
			modifier: 1,
			scale: 1,
			slideShadows: false
		},

		breakpoints: {
			768: {
				slidesPerView: 4,
				coverflowEffect: {
					rotate: 0,
					stretch: -40,
					depth: 200,
					modifier: 0.6,
					scale: 0.85,
					slideShadows: false
				}
			}
		}
	})

	// swiperEl.addEventListener('mouseover', () => {
	// 	swiper.autoplay.stop()
	// })
	// swiperEl.addEventListener('mouseleave', () => {
	// 	swiper.autoplay.start()
	// })
})

const competitionProductCarousel = qsa('[data-competition-products-swiper]')

competitionProductCarousel.forEach((module) => {
	const _swiper = qs('.swiper-container', module)
	const pagination = qs('.progress-bar', module)
	const swiper = new Swiper(_swiper, {
		direction: 'horizontal',
		autoHeight: false,
		// loop: true,
		spaceBetween: 12,
		slidesPerView: 1.5,
		mousewheel: {
			forceToAxis: true
		},
		pagination: {
			el: pagination,
			type: 'progressbar',
			clickable: true
		},
		breakpoints: {
			768: {
				slidesPerView: 3
			}
		}
	})
})

const localizationToggles = qsa('[data-localization-toggle]')

localizationToggles.forEach((toggle) => {
	toggle.addEventListener('click', (e) => {
		localization.classList.toggle('active')
	})
})

const searchItems = qsa('[data-search-results-item]')

searchItems.forEach((search) => {
	const type = search.dataset.searchResultsItem
	const amount = type == 'products' ? 3 : 2
	let idx = amount - 1
	const items = qsa('[data-search-item]', search)

	const btn = qs('[data-search-results-button]', search)

	btn &&
		btn.addEventListener('click', () => {
			idx = idx + amount
			items.forEach((item, i) => {
				if (i <= idx) {
					item.classList.remove('hidden')
				}
			})

			if (idx >= items.length) {
				btn.classList.add('hidden')
			}
		})
})

const handleSearchClick = (el) => {
	const type = el.closest('[data-search-results-item]')
	searchLoadMore(type, el)
}

const searchLoadMore = (searchEl, btn) => {
	const type = searchEl.dataset.searchResultsItem
	const amount = type == 'products' ? 3 : 2

	const _idx = Number(searchEl.dataset.idx)
	const idx = _idx + amount
	const items = qsa('[data-search-item]', searchEl)

	searchEl.dataset.idx = idx

	items.forEach((item, i) => {
		if (i <= idx) {
			item.classList.remove('hidden')
		}
	})

	if (idx >= items.length) {
		btn.classList.add('hidden')
	}
}

function initSearchSwiper() {
	const searchModalSwiper = qsa('[data-search-swiper]')

	searchModalSwiper.forEach((sw) => {
		const swiper = qs('.swiper-container', sw)

		const _swiper = new Swiper(swiper, {
			direction: 'horizontal',
			loop: false,
			autoHeight: false,
			slidesPerView: 2.25,
			spaceBetween: 12,
			loop: false,
			speed: 700,
			mousewheel: {
				forceToAxis: true
			},
			breakpoints: {
				768: {
					slidesPerView: 4
				}
			}
		})
	})
}
initSearchSwiper()

const foundersModules = qsa('[data-founders-module]')

foundersModules.forEach((module) => {
	const cards = qsa('[data-founders-item]', module)

	cards.forEach((card) => {
		card.addEventListener('mouseenter', (e) => {
			const ex = qs('[data-founders-item].active')

			ex && ex.classList.remove('active')
			card.classList.add('active')
		})
		card.addEventListener('click', (e) => {
			const ex = qs('[data-founders-item].active')

			ex && ex.classList.remove('active')
			card.classList.add('active')
		})
	})
})

/* Site Credits Toggle */

const siteCreditsToggles = qsa('[data-credits-toggle]')
const siteCredits = qs('#siteCredits')

siteCreditsToggles.forEach((toggle) => {
	toggle.addEventListener('click', (e) => {
		e.preventDefault()
		siteCredits && siteCredits.classList.toggle('active')
	})
})

/* Play button */

const playVideos = qsa('[data-play]')

playVideos.forEach((el) => {
	const btn = qs('[data-play-btn]', el)
	const video = qs('video', el)
	btn.addEventListener('click', (e) => {
		e.preventDefault()
		btn.classList.add('hidden')
		video.play()
		video.setAttribute('controls', true)
	})

	video.addEventListener('pause', (e) => {
		btn.classList.remove('hidden')
		video.removeAttribute('controls')
	})
})

const xlMediaModules = qsa('[data-xl-media]')

xlMediaModules.forEach((module) => {
	const video = qs('video', module)
	const hide = qs('[data-hide-on-play]', module)

	if (video && hide) {
		video.addEventListener('play', () => {
			hide.classList.add('hidden')
		})
		video.addEventListener('pause', () => {
			hide.classList.remove('hidden')
		})
	}
})

// Cart USP

const cartUsps = qsa('[data-usp-item]')

cartUsps.forEach((usp) => {
	const closeBtn = qs('[data-close-btn]', usp)

	usp.addEventListener('mouseover', (e) => {
		usp.classList.add('active')
	})
	usp.addEventListener('mouseleave', (e) => {
		usp.classList.remove('active')
	})

	closeBtn.addEventListener('click', (e) => {
		e.preventDefault()
		usp.classList.remove('active')
	})
})
